<script setup lang="ts">
import { onMounted, ref } from 'vue'
import { useI18n } from 'vue-i18n'
import { MarketingOptInConfirm } from '../api/Marketing'

const { t } = useI18n()

const emailAddress = ref<string | null>(null)

onMounted(async () => {
  const urlParams = new URLSearchParams(window.location.search)
  emailAddress.value = urlParams.get('confirmemail')

  if (emailAddress.value) {
    try {
      await MarketingOptInConfirm({ emailAddress: emailAddress.value })
    } catch (error) {
      console.error('Failed to confirm marketing opt-in:', error)
    }
  }
})
</script>

<template>
  <div class="marketing-confirm">
    <h2>{{ t('marketing.optInConfirm.title') }}</h2>
    <p v-if="emailAddress">
      {{ t('marketing.optInConfirm.confirmedMessage') }}
    </p>
    <p v-else>
      {{ t('marketing.optInConfirm.noEmailProvided') }}
    </p>
  </div>
</template>

<style lang="scss" scoped>
.marketing-confirm {
  text-align: center;
  padding: 2rem;
}

h2 {
  margin-bottom: 1rem;
}
</style>
